import HeadTittle from "../../../../../components/HeadTittle";
import routes from "../../../../../Routes/routes";
import {
    PersonBook
} from "../../../../../components/buttons/IconButtons";
import {USER_TYPE_NAME_MODEL} from "../../../../../enums/userTypeEnum";
import {OrderDetailApp} from "../../Functionality/OrderDetailApp";
import CustomCard from "../../../../../components/CustomCard";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import OrderData from "./OrderData";
import VehicleOrderDetail from "./VehicleOrderDetail";
import EmployeeOrderDetail from "./EmployeeOrderDetail";
import {ORDER_SECTION} from "../../../Supplier/Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * @returns {JSX.Element}
 * @constructor
 */

const OrderDetail = () => {

    const {
        userType,
        getOrderDetails,
        availableHeightColumnOneRef,
        availableHeightColumnTwoRef,
        containerHeightRef,
        renderEmployeeButton,
        renderVehicleButton
    } = OrderDetailApp();

    return (
        <>
            <HeadTittle name={'details'} link={
                userType === USER_TYPE_NAME_MODEL.EMPLOYEE
                ? routes.suppliers.main
                : userType === USER_TYPE_NAME_MODEL.SUPPLIER_IN_CHARGE
                    ? routes.suppliers.orders
                    : null
            }
            />
            <div className='row px-0 h-100'>
                <div className='col-12 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0' ref={availableHeightColumnOneRef}>
                   <OrderData
                       getOrderDetails={getOrderDetails}
                       containerHeightRef={containerHeightRef}
                       section={ORDER_SECTION.DETAILS}
                   />
                </div>
                <div className='col-12 col-lg-8 pl-0' ref={availableHeightColumnTwoRef}>
                    <CustomCard classes={'h-100'} classCard={'card-border-8px'} classContent={'p-0'}>
                        <div className='d-flex justify-content-between align-items-center m-3'>
                            <CustomGenericTittleIconDataChip
                                title={'delivery_entrance'}
                                Icon={PersonBook}
                                border={false}
                                titleBoxClass={'d-flex'}
                            />
                        </div>
                        <CustomCard classes={'mb-3'} classCard={'card-border-8px m-3'} classContent={'p-0 row mb-3'}>
                            <div className={"col-6"}>
                               <EmployeeOrderDetail
                                   getOrderDetails={getOrderDetails}
                                   renderEmployeeButton={renderEmployeeButton}
                               />
                            </div>
                            <div className={"col-6"}>
                                <VehicleOrderDetail
                                    getOrderDetails={getOrderDetails}
                                    renderVehicleButton={renderVehicleButton}
                                />
                            </div>
                        </CustomCard>
                    </CustomCard>
                </div>
            </div>
        </>
    );
};

export default OrderDetail;
